<template>
  <div id="lista-noticias" class="secao-esquerda-home">
    <div class="section-header">
      <h3>Notícias</h3>
      <h5>
        Fique por dentro das últimas notícias da extensão da UFC
      </h5>
    </div>

    <div class="filtros-container">
      <SearchInput @pesquisar="buscar" />
      <FiltroSelect v-model="filtroUnidade" :items="unidadesHome" :msg-todos="'PREX'" :uppercase="true" />
    </div>
    <div v-if="isLoading">
      <Carregamento />
    </div>
    <div v-for="noticia in noticias" :key="noticia.id" v-else-if="noticias.length > 0">
      <NoticiasCard :noticia="noticia" />
    </div>
    <div v-else>
      <AvisoListagem> Nenhuma notícia encontrada </AvisoListagem>
    </div>
    <BaseButton :to="'/noticias'"> Ver mais notícias </BaseButton>
  </div>
</template>

<script setup>
import { useNoticias } from "@/composables/useNoticias.js";
import SearchInput from "../layout/SearchInput.vue";
import NoticiasCard from "./NoticiasCard.vue";
import { onMounted, watch, ref, computed } from "vue";
import BaseButton from "../common/BaseButton.vue";
import Carregamento from "../common/Carregamento.vue";
import AvisoListagem from "../common/AvisoListagem.vue";
import FiltroSelect from "../common/FiltroSelect.vue";
import { useUnidades } from "@/composables/useUnidades.js";
import { useAuthStore } from "@/stores/auth";

const { noticias, isLoading, fetchFiltrosNoticia } = useNoticias();

const { unidades, fetchAllUnidades } = useUnidades();
const authStore = useAuthStore();

const filtroUnidade = ref("");
const termoBuscaAtual = ref("");

const unidadesHome = computed(() => {
  return [
    { id: "TODAS", nome: "TODAS AS UNIDADES", label: "TODAS AS UNIDADES" },
    ...unidades.value,
  ];
});

async function carregarNoticias() {
  let targetUnidadeId = null;
  let targetAbrangencia = null;

  if (filtroUnidade.value === "TODAS") {
    targetUnidadeId = null;
    targetAbrangencia = null;
  } else if (filtroUnidade.value) {
    targetUnidadeId = filtroUnidade.value;
    targetAbrangencia = null;
  } else {
    targetUnidadeId = null;
    targetAbrangencia = "PREX";
  }

  await fetchFiltrosNoticia({
    page: 0,
    size: 5,
    titulo: termoBuscaAtual.value,
    abrangencia: targetAbrangencia,
    unidadeId: targetUnidadeId,
  });
}

async function buscar(termoBusca) {
  termoBuscaAtual.value = termoBusca || "";
  await carregarNoticias();
}

watch(filtroUnidade, async () => {
  await carregarNoticias();
});

watch(
  () => authStore.isAutenticado,
  async () => {
    await carregarNoticias();
  }
);

onMounted(async () => {
  await Promise.all([carregarNoticias(), fetchAllUnidades(0, 1000)]);
});
</script>

<style scoped>
.filtros-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  width: 100%;
}

.secao-esquerda-home {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.section-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--cinza-medio);
  width: 100%;
}

.section-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

.section-header h5 {
  font-size: 1rem;
  font-weight: 300;
}

@media (max-width: 600px) {
  .filtros-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }
}
</style>
